module.exports = __webpack_public_path__ + "static/img/10009 (4).dcc20c6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10009 (4).webp
// module id = /5sb
// module chunks = 14